import * as jQuery from 'jquery';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'vue-wysiwyg/dist/vueWysiwyg.css';
import './assets/sb-admin.css';
import VeeValidate, { Validator } from 'vee-validate';
import { VueFormatDate } from './filters/date.filter';
import Notifications from 'vue-notification';
import Paginate from 'vuejs-paginate';
import wysiwyg from 'vue-wysiwyg';

/* tslint:disable */
const fr = require('vee-validate/dist/locale/fr');
/* tslint:enable */

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faBars,
  faUserCircle,
  faPowerOff,
  faBriefcase,
  faUsers,
  faPlus,
  faTrashAlt,
  faClone,
  faEdit,
  faArrowLeft,
  faInfoCircle,
} from '@fortawesome/free-solid-svg-icons';
/* tslint:disable:no-var-requires */
const fontawesome = require('@fortawesome/vue-fontawesome');

library.add(
  faBars,
  faUserCircle,
  faPowerOff,
  faBriefcase,
  faUsers,
  faPlus,
  faTrashAlt,
  faClone,
  faEdit,
  faArrowLeft,
  faInfoCircle,
);

Vue.component('font-awesome-icon', fontawesome.FontAwesomeIcon);
Vue.component('paginate', Paginate);
Vue.use(VeeValidate, {
  locale: 'fr',
  classes: true,
  classNames: {
    valid: 'is-valid',
    invalid: 'is-invalid',
  },
});
Vue.use(Notifications);
Vue.use(wysiwyg);
Vue.use(VueFormatDate);
Validator.localize({
  fr,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
